// @flow

import { noteNotification } from 'common/notification'
import { sendDataToMetabase } from 'common/send-data-to-metabase'

import { getCurrentStep } from './get-current-step'
import { switchToNextStep } from './switch-to-next-step'

export const submitFormOlympHome = async (event: Event) => {
  event.preventDefault()
  event.stopPropagation()

  if (!(event.currentTarget instanceof HTMLFormElement)) {
    return
  }

  const step = getCurrentStep()

  if (step === 2) {
    // $FlowFixMe
    const formData = new FormData(event.target)
    const entries = Object.fromEntries(formData.entries())

    delete entries['Checkbox']

    const data: { [key: string]: any } = {
      ...entries,
      birthday: new Date((entries.birthday: any)).toLocaleDateString('ru-RU'),
    }

    const response = await sendDataToMetabase('olymp', data)

    if (response.status === 200) {
      document.querySelector('.enroll__main-state')?.classList.remove('active')
      document.querySelector('.enroll__success-state')?.classList.add('active')
    } else {
      noteNotification('Что-то пошло не так. Попробуйте перезагрузить страницу')
    }
  } else {
    switchToNextStep(step)
  }
}
